// Environment-based configuration.
// Set REACT_APP_ENVIRONMENT in .env to one of: LOCAL, DEV, PROD
// The app will automatically use the correct URLs for that environment.

const API_CLIENTS = {
  LOCAL: "https://qa.api.deloittegithub.com",
  DEV: "https://qa.api.deloittegithub.com",
  QA: "https://qa.api.deloittegithub.com",
  STAGE: "https://qa.api.deloittegithub.com",
  PROD: "https://api.deloittegithub.com",
};

const currentEnv = process.env.REACT_APP_ENVIRONMENT || "LOCAL";
const config = API_CLIENTS[currentEnv];

if (!config) {
  throw new Error(
    `Unknown REACT_APP_ENVIRONMENT: "${currentEnv}". Expected one of: ${Object.keys(API_CLIENTS).join(", ")}`
  );
}

export default config;
